import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SharedService } from 'src/app/shared/common-services/shared.service';
import { leftMainMenu } from '../menu/leftMainMenuList';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard  {
  constructor(private _sharedService: SharedService) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const moduleName = state?.url?.split('/')?.length > 1 ? state?.url?.split('/')?.[1] : null;
    const privilege: any = leftMainMenu?.menu?.find((elem: any) => elem?.nav === moduleName)?.privilege;
    if (!this._sharedService.rbacManagement(privilege)) {
      this._sharedService.noPrivilegeNavigate();
      return false;
    } else {
      return true;
    }
  }

}
